/* eslint-disable */
import {AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';

export const registerLogo = (payload: any): Promise<AxiosResponse> => HttpRequest.post('api/auth/save/logo', payload);

export const getLogo = (): Promise<AxiosResponse> => HttpRequest.get('api/auth/get/logo');

/*
type LogoType = {
    progressEvent?: (progressEvent: any) => void
}
export const downloadLogo = (props: LogoType): Promise<AxiosResponse> => HttpRequest.get('api/auth/download/logo', {
    onDownloadProgress: props?.progressEvent
});*/
